import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { getTestIds } from '../../../../utils/TestIds';
import { Column } from '../../../Layout';
import styles from '../table.module.scss';
export function TableSurface(param) {
    let { scrollerRef, onScroll, framed, interactive = true, scrollable = true, fillsHost = false, clipsColumns = false, hasRowsBelow = false, sidewaysScroll, children, testId } = param;
    const testIds = useMemo(()=>getTestIds(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 0,
        className: cn(styles.surface, {
            [styles.uncappedHeight]: !scrollable,
            [styles.fillsHost]: scrollable && fillsHost
        }),
        testId: testId,
        children: [
            /*#__PURE__*/ _jsx("div", {
                ref: scrollerRef,
                className: cn(styles.scroller, {
                    [styles.fixedWidth]: clipsColumns
                }),
                tabIndex: 0,
                onScroll: onScroll,
                "data-scroller": true,
                "data-testid": testId == null ? undefined : testIds.scroller(),
                children: /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.table, {
                        [styles.unifiedTable]: framed,
                        [styles.staticTable]: !interactive
                    }),
                    children: children
                })
            }),
            sidewaysScroll != null && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        "aria-hidden": true,
                        className: cn(styles.sideFade, styles.startFade, {
                            [styles.hidden]: !sidewaysScroll.isScrolledX
                        }),
                        "data-testid": testId == null ? undefined : testIds.startFade()
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        "aria-hidden": true,
                        className: cn(styles.sideFade, styles.endFade, {
                            [styles.hidden]: !sidewaysScroll.hasColumnsBeyondEnd
                        }),
                        "data-testid": testId == null ? undefined : testIds.endFade()
                    })
                ]
            }),
            scrollable && /*#__PURE__*/ _jsx("div", {
                "aria-hidden": true,
                className: cn(styles.bottomFade, {
                    [styles.hidden]: !hasRowsBelow
                }),
                "data-testid": testId == null ? undefined : testIds.bottomFade()
            })
        ]
    });
}
